"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var react_2 = require("@headlessui/react");
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var uuid_1 = require("uuid");
var console_1 = require("@kaizen/component-library/util/console");
var ModalAccessibleContext_1 = require("./ModalAccessibleContext");
var GenericModal_module_scss_1 = __importDefault(require("./GenericModal.module.scss"));
var GenericModalContainer = function (props) {
    var labelledByID = (0, uuid_1.v4)();
    var describedByID = (0, uuid_1.v4)();
    return (react_1["default"].createElement(ModalAccessibleContext_1.ModalAccessibleContext.Provider, { value: {
            labelledByID: labelledByID,
            describedByID: describedByID
        } },
        react_1["default"].createElement(GenericModal, __assign({}, props, { labelledByID: labelledByID, describedByID: describedByID }))));
};
var GenericModal = /** @class */ (function (_super) {
    __extends(GenericModal, _super);
    function GenericModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollLayer = null;
        _this.modalLayer = null;
        _this.escapeKeyHandler = function (event) {
            if (event.key === "Escape" ||
                event.key === "Esc" // IE11
            )
                _this.props.onEscapeKeyup && _this.props.onEscapeKeyup(event);
        };
        _this.outsideModalClickHandler = function (event) {
            if (event.target === _this.scrollLayer || event.target === _this.modalLayer) {
                _this.props.onOutsideModalClick && _this.props.onOutsideModalClick(event);
            }
        };
        return _this;
    }
    GenericModal.prototype.componentWillUnmount = function () {
        /*
          Sometimes consumers control rendering modals without the
          isOpen prop: e.g {isShowing && (<Modal />)}
          So we need to cleanup after ourselves in onUnmount as well
          as onAfterLeave (the callback from the Transition library).
        */
        this.onAfterLeave();
    };
    GenericModal.prototype.onBeforeEnter = function () {
        this.addEventHandlers();
        this.preventBodyScroll();
    };
    GenericModal.prototype.onAfterEnter = function () {
        this.scrollModalToTop();
        this.ensureAccessiblityIsMet();
        this.focusAccessibleLabel();
        if (this.modalLayer) {
            this.removeAriaHider = createAriaHider(this.modalLayer);
        }
    };
    GenericModal.prototype.onAfterLeave = function () {
        this.removeEventHandlers();
        this.restoreBodyScroll();
        this.removeAriaHider();
        this.props.onAfterLeave && this.props.onAfterLeave();
    };
    GenericModal.prototype.addEventHandlers = function () {
        this.props.onEscapeKeyup &&
            document.addEventListener("keyup", this.escapeKeyHandler);
    };
    GenericModal.prototype.removeEventHandlers = function () {
        this.props.onEscapeKeyup &&
            document.removeEventListener("keyup", this.escapeKeyHandler);
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    GenericModal.prototype.removeAriaHider = function () { };
    GenericModal.prototype.preventBodyScroll = function () {
        var _a;
        var hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
        var scrollStyles = [GenericModal_module_scss_1["default"].unscrollable];
        if (hasScrollbar) {
            scrollStyles.push(GenericModal_module_scss_1["default"].pseudoScrollbar);
        }
        (_a = document.documentElement.classList).add.apply(_a, scrollStyles);
    };
    GenericModal.prototype.restoreBodyScroll = function () {
        document.documentElement.classList.remove(GenericModal_module_scss_1["default"].unscrollable, GenericModal_module_scss_1["default"].pseudoScrollbar);
    };
    GenericModal.prototype.ensureAccessiblityIsMet = function () {
        if (!this.modalLayer)
            return;
        // Ensure that consumers have provided an element that labels the modal
        // to meet ARIA accessibility guidelines.
        if (!document.getElementById(this.props.labelledByID)) {
            (0, console_1.warn)("When using the Modal component, you must provide a label for the modal.\n        Make sure you have a <ModalAccessibleLabel /> component with content that labels the modal.");
        }
    };
    GenericModal.prototype.scrollModalToTop = function () {
        var _this = this;
        // If we have a really long modal, the autofocus could land on an element down below
        // causing the modal to scroll down and skipping over the content near the modal's top.
        // Ensure that when the modal opens, we are at the top of its content.
        requestAnimationFrame(function () {
            if (!_this.scrollLayer)
                return;
            _this.scrollLayer.scrollTop = 0;
        });
    };
    GenericModal.prototype.focusAccessibleLabel = function () {
        if (this.modalLayer) {
            var labelElement = document.getElementById(this.props.labelledByID);
            if (labelElement) {
                labelElement.focus();
            }
        }
    };
    GenericModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpen = _a.isOpen, children = _a.children, _b = _a.focusLockDisabled, focusLockDisabled = _b === void 0 ? false : _b, automationId = _a.automationId;
        return (0, react_dom_1.createPortal)(react_1["default"].createElement(react_2.Transition, { appear: true, show: isOpen, enter: GenericModal_module_scss_1["default"].animatingEnter, leave: GenericModal_module_scss_1["default"].animatingLeave, beforeEnter: function () { return _this.onBeforeEnter(); }, afterEnter: function () { return _this.onAfterEnter(); }, afterLeave: function () { return _this.onAfterLeave(); }, "data-generic-modal-transition-wrapper": true, onClick: function (e) { return e.stopPropagation(); } },
            react_1["default"].createElement(react_focus_lock_1["default"], { disabled: focusLockDisabled, returnFocus: true, 
                // Disabling false positive
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: false },
                react_1["default"].createElement("div", { className: GenericModal_module_scss_1["default"].backdropLayer }),
                react_1["default"].createElement("div", { className: GenericModal_module_scss_1["default"].scrollLayer, ref: function (scrollLayer) {
                        return (_this.scrollLayer = scrollLayer);
                    }, onClick: this.props.onOutsideModalClick && this.outsideModalClickHandler, "data-automation-id": "".concat(automationId, "-scrollLayer"), "data-testid": "".concat(automationId, "-scrollLayer") },
                    react_1["default"].createElement("div", { role: "dialog", "aria-labelledby": this.props.labelledByID, "aria-describedby": this.props.describedByID, className: GenericModal_module_scss_1["default"].modalLayer, ref: function (modalLayer) {
                            return (_this.modalLayer = modalLayer);
                        }, "data-automation-id": automationId, "data-testid": automationId }, children)))), document.body);
    };
    return GenericModal;
}(react_1["default"].Component));
/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 */
var getOwnerDocument = function (element) {
    return element && element.ownerDocument
        ? element.ownerDocument
        : canUseDOM()
            ? document
            : null;
};
/**
 * Check if the DOM exists and is usable
 */
var canUseDOM = function () {
    return typeof window !== "undefined" &&
        typeof window.document !== "undefined" &&
        typeof window.document.createElement !== "undefined";
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function () { };
/**
 * Hide elements in the DOM from screenreaders that are outside the parent tree
 * of the reference node. We do this by setting `aria-hidden` attribute to true
 * for any elements top-level DOM nodes.
 *
 * Returns a function that restores the _original_ values of the affected nodes,
 * so any pre-aria-hidden values will continue to stay hidden.
 */
var createAriaHider = function (dialogNode) {
    var originalValues = [];
    var rootNodes = [];
    var ownerDocument = getOwnerDocument(dialogNode) || document;
    if (!dialogNode) {
        return noop;
    }
    Array.prototype.forEach.call(ownerDocument.querySelectorAll("body > *"), function (node) {
        var _a, _b;
        var portalNode = (_b = (_a = dialogNode.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode;
        if (node === portalNode) {
            return;
        }
        var attr = node.getAttribute("aria-hidden");
        var alreadyHidden = attr !== null && attr !== "false";
        if (alreadyHidden) {
            return;
        }
        originalValues.push(attr);
        rootNodes.push(node);
        node.setAttribute("aria-hidden", "true");
    });
    return function () {
        rootNodes.forEach(function (node, index) {
            var originalValue = originalValues[index];
            if (originalValue === null) {
                node.removeAttribute("aria-hidden");
            }
            else {
                node.setAttribute("aria-hidden", originalValue);
            }
        });
    };
};
exports["default"] = GenericModalContainer;
//# sourceMappingURL=GenericModal.js.map